import styled from 'styled-components';


export const ApikoImg = styled.img`
  width: 113px;
  height: 46px;
  object-fit: contain;
  display: block;
  margin: 30px auto;
`;

export const PreviewPageWrap = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 10px;
`;



// WEBPACK FOOTER //
// ./src/layouts/preview/styles.js